export default "__VITE_ASSET__bf056baa__"